import { APPROVED_ALASKA_LANDSCAPE, APPROVED_KITCHEN_LANDSCAPE } from "../lib/approvedVisuals";

export const CATEGORY_IMAGE_DEFAULTS = {
  "Baked Goods": "/approved-food/bakery.jpeg",
  Desserts: "/approved-food/dessert.jpeg",
  Drinks: "/approved-food/drinks.jpg",
  "Fresh Produce": "/approved-food/fresh-produce.jpg",
  "Hot Meals": "",
  "Meal Prep": "/approved-food/bowls.jpeg",
  Sides: "/approved-food/sides.jpg",
};

export const SITE_DEFAULTS = {
  appearance: {
    palette_version: 1,
    primary: "#C25A2E",
    primary_hover_dark: "#C25A2E",
    primary_hover_light: "#C25A2E",
    accent: "#C25A2E",
    text: "#0E2A47",
    text_muted: "#0E2A47",
    border: "#F1E4D6",
    alaska_backdrop_image: APPROVED_ALASKA_LANDSCAPE,
  },
  homepage: {
    badge_text: "Alaska local food marketplace",
    headline: "Order local food from",
    headline_emphasis: "Alaska kitchens.",
    subheadline: "Home cooks, bakers, food trucks, caterers, and local kitchens. Find pickup, available delivery, and limited preorder drops in one place.",
    search_placeholder: "Search food, cuisines, or kitchens",
    primary_cta_label: "Browse food",
    primary_cta_route: "#available-now",
    secondary_cta_label: "Local kitchens",
    secondary_cta_route: "#kitchens",
    hero_background_image: "/customer-final/bread-pudding.jpg",
    hero_video_enabled: true,
    category_images: {
      "Baked Goods": "",
      Desserts: "",
      Drinks: "",
      "Fresh Produce": "",
      "Hot Meals": "",
      "Meal Prep": "",
      Sides: "",
    },
    hero_images: [
      "/customer-final/raspberry-panna-cotta.jpg",
      "/customer-final/burger.jpg",
      "/customer-final/tacos.webp",
    ],
    sections: [
      { key: "announcements", enabled: true },
      { key: "newsletter", enabled: true },
      { key: "hero", enabled: true },
      { key: "categories", enabled: true },
      { key: "marketplace", enabled: true },
      { key: "trust", enabled: true },
      { key: "faq", enabled: true },
    ],
  },
  seller_page: {
    hero_image: APPROVED_KITCHEN_LANDSCAPE,
  },
  marketplace: {
    vendor_order: "featured_first",
    featured_vendor_ids: [],
    vendor_cards_per_section: 100,
    promotional_badges: {},
    section_label_default: "Local Kitchens",
    section_title_default: "Independent Alaska kitchens",
    section_description_default: "Discover independent kitchens, bakers, food trucks, meal-prep businesses, and caterers across Arctic Plate.",
    section_label_founding: "Local Kitchens",
    section_title_founding: "Independent Alaska kitchens",
    section_description_founding: "Browse approved public kitchens and their current menus, pickup options, and available delivery choices.",
  },
  content: {
    trust_cards: [
      { title: "Independent Alaska food businesses", body: "Browse approved public kitchens and the food they currently list on Arctic Plate." },
      { title: "Stripe-powered checkout", body: "Eligible card payments use Arctic Plate's hosted Stripe checkout flow." },
      { title: "Pickup and delivery choices", body: "Each kitchen controls the fulfillment options available for its business." },
    ],
    newsletter_heading: "Stay updated",
    newsletter_body: "about new kitchens, cities, promotions, and features.",
    newsletter_button_label: "Subscribe",
    newsletter_more_label: "More",
    marketplace_empty_eyebrow: "Local Kitchens",
    marketplace_empty_title: "Arctic Plate is growing across Alaska.",
    marketplace_empty_body: "We're welcoming independent local kitchens — bakers, cooks, meal-prep businesses, caterers, and other food businesses — one kitchen at a time. Check back for new local options or share Arctic Plate with an Alaska food maker you love.",
    marketplace_empty_cta_label: "Sell on Arctic Plate",
    search_empty_eyebrow: "No matches",
    search_empty_title: "Try a different craving",
    search_empty_body: "Clear your search or explore other categories above.",
    clear_filters_label: "Clear filters",
    seller_cta_text: "Local food kitchen? Learn how Arctic Plate works for independent kitchens.",
    seller_cta_label: "For businesses",
    faq_intro: "What Arctic Plate is — and what it isn't.",
    faq_entries: [
      { question: "Is Arctic Plate only for homemade food?", answer: "No. Arctic Plate is an Alaska local food marketplace connecting customers with independent local food kitchens. Homemade food may be available, along with meals, baked goods, desserts, meal prep, catering, specialty foods, and other approved local options." },
      { question: "Is every kitchen a home kitchen?", answer: "No. Kitchens may operate different types of local food businesses and preparation environments. Each kitchen profile and applicable disclosures should explain the information relevant to that kitchen." },
      { question: "Is every product prepared in a home kitchen?", answer: "No. Preparation environments may differ by kitchen and product. Review each kitchen's profile, product details, and applicable disclosures before ordering." },
    ],
    faq_footer: "Additional approved local food options may be introduced as Arctic Plate grows.",
  },
  navigation: {
    brand_label: "Arctic Plate",
    logo_image: "",
    sell_food_label: "For businesses",
    login_label: "Log in",
    optional_links: [],
  },
  footer: {
    enabled: false,
    heading: "Arctic Plate",
    support_text: "Questions? Contact support@arcticplate.com.",
    links: [
      { label: "About", route: "/about" },
      { label: "Fees & delivery", route: "/fees-delivery" },
      { label: "Support", route: "/support" },
      { label: "Sell food", route: "/sell-food" },
    ],
    social_links: [],
    copyright_text: "Arctic Plate",
  },
  seo: {
    pages: {
      home: {
        title: "Arctic Plate | Alaska Local Food Marketplace",
        description: "Discover independent Alaska kitchens, bakers, meal-prep businesses, caterers, and other approved local food businesses.",
      },
      sell_food: {
        title: "Sell Food on Arctic Plate",
        description: "Apply to sell approved local food through Arctic Plate.",
      },
      about: {
        title: "About Arctic Plate | Alaska Local Food Marketplace",
        description: "Learn how Arctic Plate connects Alaska customers with independent local food sellers and flexible fulfillment options.",
      },
      fees_delivery: {
        title: "Customer Fees & Delivery | Arctic Plate",
        description: "Understand Arctic Plate customer service fees, seller delivery, pickup, and Arctic Plate delivery before checkout.",
      },
      support: {
        title: "Arctic Plate Support",
        description: "Get help with your Arctic Plate account, order, or seller experience.",
      },
      subscribe: {
        title: "Stay Updated | Arctic Plate",
        description: "Subscribe for Arctic Plate marketplace updates and new local seller announcements.",
      },
    },
  },
};

export function cloneSiteDefaults() {
  return JSON.parse(JSON.stringify(SITE_DEFAULTS));
}

